import { useState, useEffect } from "react";
import styles from "./FourQuadInteractive.module.scss";
import {
  Col,
  Row,
  Container,
  CustomContainer,
} from "../../atoms/DependencyHelper";
import Proposition from "../../molecules/proposition/Proposition";
import Carousel from "../../molecules/carousel/Carousel";
import Image from "../../atoms/image/image";
import HomePageHeading from "../../molecules/homePageHeading/homePageHeading";

import PropTypes from "prop-types";
import PageHeading from "../../atoms/pageHeading/PageHeading";

const FourQuadInteractive = ({ content, data }) => {
  const [indexActive, setIndexActive] = useState(0);
  const [activeImage, setActiveImage] = useState(content[indexActive].image);
  const [quadrants, setQuadrants] = useState({ left: [], right: [] });

  const handleOnClick = (index) => {
    if (index !== indexActive) {
      setIndexActive(index);
    }
  };

  const buildQuadrant = (index, isActive, item, align) => (
    <Proposition
      data={item}
      onClick={() => handleOnClick(index)}
      align={align}
      isActive={isActive}
      isStatic={data.staticImage}
    />
  );

  const buildQuadrants = (items) => {
    let quadrantsLeft = [];
    let quadrantsRight = [];

    items.map((item, index) => {
      const isActive = data.staticImage ? true : index === indexActive;
      if (index % 2 === 0) {
        quadrantsLeft.push(
          <Col key={index}>
            {buildQuadrant(index, isActive, item, "right", true)}
          </Col>
        );
      } else {
        quadrantsRight.push(
          <Col key={index}>
            {buildQuadrant(index, isActive, item, "left", true)}
          </Col>
        );
      }

      setQuadrants({ left: quadrantsLeft, right: quadrantsRight });
    });
  };

  useEffect(() => {
    buildQuadrants(content);
    setActiveImage(content[indexActive].image);
  }, [indexActive]);

  const generateAlignment = () => {
    switch (data?.heading_position) {
      case "left":
      case "LEFT": {
        return data?.heading_position ? "text-left" : "";
      }
      case "right":
      case "RIGHT": {
        return data?.heading_position ? "text-right" : "";
      }
      default:
        return "text-center";
    }
  };
  return (
    <>
      <Container>
        <PageHeading
          text={data.componentTitle}
          className={`${styles["main-heading"]} ${generateAlignment()} `}
        />
        <PageHeading
          text={data.componentHeading}
          className={`${styles["heading"]} ${generateAlignment()} `}
        />
        <PageHeading
          level={4}
          text={data.componentDescription}
          className={`${
            styles["main-description"]
          } d-flex ${generateAlignment()} `}
        />
      </Container>
      <Container>
        <Row className="d-none d-lg-flex align-items-center">
          <Col>
            <Row md={1} className={styles["quadrant"]}>
              {quadrants.left}
            </Row>
          </Col>
          <Col md="auto">
            <Container
              className={styles["quadrant-image-container"]}
              style={{
                backgroundImage: `url(${
                  data.staticImage ? data.staticImage : activeImage
                })`,
              }}
            ></Container>
          </Col>
          <Col>
            <Row md={1} className={styles["quadrant"]}>
              {quadrants.right}
            </Row>
          </Col>
        </Row>
      </Container>
      <Container bsPrefix={styles["container-mobile"]} className="d-lg-none">
        {data.staticImage && (
          <CustomContainer
            className={`d-flex justify-content-center ${styles["quadrant-mobile "]}`}
          >
            <Image
              img_path={data?.staticImage}
              className={styles["quadrant-image"]}
            />
          </CustomContainer>
        )}
        <Carousel
          showNav={true}
          navClassName={`${styles["carousel-nav"]} ${
            styles[data.staticImage && "carousel-nav--static"]
          }`}
        >
          {content.map((item, index) => {
            return (
              <Container
                key={index}
                bsPrefix={styles["carousel-container"]}
                className={`d-flex flex-column justify-content-center`}
              >
                {!data.staticImage && (
                  <CustomContainer className="d-flex justify-content-center ">
                    <Image
                      img_path={item.image}
                      className={styles["quadrant-image"]}
                    />
                  </CustomContainer>
                )}
                <CustomContainer
                  className={`${
                    styles[!data.staticImage && "quadrant-mobile"]
                  }`}
                >
                  <Proposition
                    data={item}
                    align="left"
                    isActive={true}
                    showIcon={false}
                  />
                </CustomContainer>
              </Container>
            );
          })}
        </Carousel>
      </Container>
    </>
  );
};

FourQuadInteractive.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      icon: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

export default FourQuadInteractive;
